'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var CalendarUtil = function () {
  function CalendarUtil() {
    _classCallCheck(this, CalendarUtil);
  }

  _createClass(CalendarUtil, null, [{
    key: 'addMonth',
    value: function addMonth(startDate, val) {
      return new Date(new Date(startDate).setMonth(startDate.getMonth() + val));
    }
  }, {
    key: 'getFirstOfCurrentMonth',
    value: function getFirstOfCurrentMonth() {
      var today = new Date();
      return new Date(today.getFullYear(), today.getMonth(), 1);
    }
  }, {
    key: 'getTimeFromTimestamp',
    value: function getTimeFromTimestamp(timestamp) {
      var t = new Date(timestamp * 1000);
      return t.toLocaleDateString() + " " + t.toLocaleTimeString(navigator.language, {
        hour: '2-digit',
        minute: '2-digit'
      }); //("dd.mm.yyyy hh:MM Uhr")
    }
  }, {
    key: 'createDropDownData',
    value: function createDropDownData(availableTimes) {
      var result = [];
      var lastHour = -1;
      var hasAvailableTimes = false;
      var currentHour = {};

      for (var i = 0; i < availableTimes.length; i++) {
        var offset = availableTimes[i].TimeSlotOffset;
        var hour = Math.trunc(offset / 60);
        var minute = offset % 60;
        var isAvailable = availableTimes[i].IsAvailable;

        if (hour != lastHour) {
          if (lastHour != -1) {
            result[lastHour] = {
              hasAvailableTimes: hasAvailableTimes,
              minutes: currentHour
            };
            currentHour = {};
            hasAvailableTimes = false;
          }

          lastHour = hour;
        }

        if (isAvailable) hasAvailableTimes = true;
        currentHour[minute] = isAvailable;
      }

      if (lastHour != -1) {
        result[lastHour] = {
          hasAvailableTimes: hasAvailableTimes,
          minutes: currentHour
        };
      }

      return result;
    }
  }]);

  return CalendarUtil;
}();

exports.default = CalendarUtil;